import { axiosMockAdapterInstance as mock } from '../axiosInstance';
import mockDataTagFilter from './data/mock-tags-filters-api.json';
import envVariables from "../utils/config.json";

const mockGetTagFilters = mock
  .onGet(`${process.env.REACT_APP_BASE_URL || envVariables.REACT_APP_BASE_URL}/tagFilter`)
  .reply(function () { return [200, mockDataTagFilter.tagList] }
  )

export { mockGetTagFilters }